exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".kbm-links[data-v-32a4270a]{padding:25px 15px}.kbm-links a[data-v-32a4270a]{font-size:18px;text-decoration:underline!important;margin:5px 0;font-weight:700}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-32a4270a","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/js/components/elements/KbmLinks.vue
// module id = nhzC
// module chunks = 0